import {
  parseAsArrayOf,
  parseAsString,
  parseAsStringLiteral,
  useQueryStates,
} from "nuqs";

import { organizationTypeParams } from "~/admins/constants/organizations";

export const organizationFiltersParser = {
  order_by: parseAsString.withDefault("name"),
  name: parseAsString.withDefault(""),
  types: parseAsArrayOf(
    parseAsStringLiteral(organizationTypeParams),
  ).withDefault([...organizationTypeParams]),
};

export const useOrganizationFilters = () => {
  return useQueryStates(organizationFiltersParser);
};
